module.exports = __webpack_public_path__ + "img/40_69_000_950.d1d88a07.jpg";